module.exports = __webpack_public_path__ + "static/media/me.ab3fa254.svg";